(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ReportGroupDetailController', ReportGroupDetailController);

    ReportGroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ReportGroup', 'Clinic', 'Corporation'];

    function ReportGroupDetailController($scope, $rootScope, $stateParams, previousState, entity, ReportGroup, Clinic, Corporation) {
        var vm = this;

        vm.reportGroup = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:reportGroupUpdate', function(event, result) {
            vm.reportGroup = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
